// extracted by mini-css-extract-plugin
export default {"firstScreenCon":"firstScreenCon--Fi9ZN","markerAnimationScale":"markerAnimationScale--EBSwH"};